import React, { useState, useRef } from 'react';
import toast from 'react-hot-toast';
import GameKeypad from './GameKeypad';

function NumberPickerStrike({ game, selectedNumbers, onSelect, onRemove, blockedPickNumbers, maxSelectableNumbers }) {
  const blocked = blockedPickNumbers ?? new Set(selectedNumbers);
  const maxPicks = maxSelectableNumbers ?? game.maxNumbersPerTicket;
  const [inputBuffer, setInputBuffer] = useState('');
  const clearTimeoutRef = useRef(null);

  const clearDisplay = () => {
    if (clearTimeoutRef.current) {
      clearTimeout(clearTimeoutRef.current);
      clearTimeoutRef.current = null;
    }
    setInputBuffer('');
  };

  const handleDigit = (digit) => {
    const num = parseInt(digit, 10);

    // If already selected, show toast and clear
    if (blocked.has(num)) {
      toast.error(`Number ${num} already selected`);
      clearDisplay();
      return;
    }

    // If at max capacity, show toast and clear
    if (selectedNumbers.length >= maxPicks) {
      toast.error(`Maximum ${maxPicks} numbers allowed this round`);
      clearDisplay();
      return;
    }

    // Clear any pending display clear
    clearDisplay();

    // Show digit in display
    setInputBuffer(digit);
    onSelect(num);

    // Clear display after 500ms
    clearTimeoutRef.current = setTimeout(() => {
      setInputBuffer('');
      clearTimeoutRef.current = null;
    }, 500);
  };

  const handleBackspace = () => {
    // No-op: backspace is disabled in Strike
  };

  const handleClear = () => {
    clearDisplay();
  };

  // Gray out digits that are already selected or when at max capacity
  const getDisabledButtons = () => {
    const disabled = ['clear', 'backspace'];
    for (let d = 0; d <= 9; d++) {
      if (blocked.has(d) || selectedNumbers.length >= maxPicks) {
        disabled.push(String(d));
      }
    }
    return disabled;
  };

  return (
    <div className="space-y-4">
      {/* Display */}
      <div className="flex items-center justify-center">
        <div className="w-full max-w-xs">
          <div className="dark-input text-center text-2xl font-mono font-bold tracking-widest py-4 min-h-[60px] flex items-center justify-center">
            {inputBuffer || '_'}
          </div>
        </div>
      </div>

      {/* Keypad */}
      <div className="max-w-xs mx-auto">
        <GameKeypad
          onDigit={handleDigit}
          onBackspace={handleBackspace}
          onClear={handleClear}
          disabledButtons={getDisabledButtons()}
        />
      </div>
    </div>
  );
}

export default NumberPickerStrike;
